var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationModal',{attrs:{"bodyText":"","cancelText":"","headerText":"No policies applied"},scopedSlots:_vm._u([{key:"message",fn:function(){return [_c('p',[_vm._v(" You need to apply at least one policy to this policy group first. Return to the Policies tab to apply one. ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }